<template>
  <gj-modal
      size="650_auto"
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
      no-padding
      @cancel="cancel"
      @confirm="confirm"
  >
    <template #header>编辑标签</template>
    <template #content>
      <template>
        <div class="gj-picker__table">
          <el-form ref="form" :model="listItem" label-width="85px">
            <el-form-item
                label="已选标签："
                prop="tagIds"
                class="setting-wrapper"
                :rules="[{ validator: tagValidator, message: '请至少选择一个标签', trigger: ['blur', 'change'] }]"
            >
                <span v-for="(i, index) in tagList" :key="index">
                  <gj-tag
                      :color="tagColors.orange"
                      type="plain"
                      :closable="true"
                      @close="close(i)"
                  >{{ i.text }}</gj-tag>
                </span>
              <div>
                <gj-select
                    v-model="listItem.tagIds"
                    :options="options"
                    placeholder="选择标签"
                    type="multi-check"
                    width="150px"
                    :key="'id'"
                    :filterable="false"
                ></gj-select>
                <span class="setting-icon"
                      v-if="$permission('tag:view')"
                      @click="$router.push({path: '/crm/tag-manager'})">
                    <gj-icon class="el-icon-setting" style="margin-left: 4px;color: #666666"></gj-icon>
                </span>
              </div>
            </el-form-item>
            <el-form-item label="备注：" prop="desc" style="margin-bottom: 0">
              <gj-textarea
                  v-model="listItem.memo"
                  :styles="{ height: '120px', width: '400px' }"
                  maxlength="50"
                  @input="$refs.form.validate()"
              >
              </gj-textarea>
            </el-form-item>
          </el-form>
        </div>

      </template>
    </template>
  </gj-modal>
</template>

<script>
import {
  modalMixIn,
  formRuleMixin,
  responseMixin,
  formMixin,
  queryMixin,
} from "../../../../../minxins";
import {getActiveTag, saveTagToListing} from "../../../../../api/common";
import {tagColors} from "@/components/tag/tag-colors";
import {isMeaningful} from "@/utils/common";

export default {
  name: "mail-tags-modal",
  mixins: [
    modalMixIn,
    // formRuleMixin,
    responseMixin,
    // formMixin,
    queryMixin,
  ],
  props: {
    item: null,//商品详情
    marketId: null,//店铺id
    orderId: null,//订单id
    mailType: null,
    ticketId: null, // 邮件id
  },
  data() {
    return {
      confirmLoading: false,
      options: [],

      listItem: {
        tagIds: [],
        memo: ''
      },

      loading: true,

      form: {},
      tagColors
    };
  },
  created() {
    this.listItem = {
      ...this._.cloneDeep(this.item),
      tagIds: this.item.tags ? this.item.tags.map(r => r.id) : []
    };
    this.queryData();
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        if (from && from.path === '/crm/tag-manager') {
          this.queryData();
        }
      }
    }
  },
  computed: {
    tagList() {
      if (!this.listItem.tagIds) {
        return [];
      }
      const arr = [];
      for (const index in this.listItem.tagIds) {
        for (const index1 in this.options) {
          if (this.listItem.tagIds[index] == this.options[index1].id) {
            arr.push(this.options[index1]);
          }
        }
      }
      return arr;
    },
  },
  methods: {
    tagValidator (rule, value, callback){
      if(isMeaningful(this.listItem.memo)&&!this.listItem.tagIds.length){
        callback(false)
      }else {
        callback()
      }
    },
    //获取全部标签列表
    queryData() {
      this.loading = true;
      getActiveTag({
        module: "Email",
        orderId: this.orderId,
        asin: this.listItem.asin
      })
          .then((res) => {
            this.options = res;
          })
          .complete(() => (this.loading = false));
    },

    // 删除标签
    close(tag) {
      const arr = this.listItem.tagIds.filter((item, index) => {
        if (item != tag.id) {
          return item;
        }
      });
      this.listItem.tagIds = arr;
    },

    //提交
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          const params = {
            module: this.mailType === 'BuyerEmail' ? 'Email' : "EmailOrderListing",//module
            fid: this.listItem.listtingId,//商品id
            marketId: this.marketId,//店铺id
            orderId: this.orderId,//订单id
            tagAndAsinDTOList: [this.listItem],//商品详情
            ticketId:this.ticketId,// 邮件id
          };
          saveTagToListing(params)
              .then((res) => {
                this.$gjResponseHandle(res, () => {
                  this.$gjMessage.success("编辑标签成功");
                  this.$emit("created");
                  this.$gjDestroy();
                });
              })
              .complete(() => {
                this.confirmLoading = false;
              });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
// @import "picker";
.marBottom {
  margin-bottom: 15px;
}

.boldSpan {
  font-weight: bold;
  color: #333;
  display: inline-block;
}

.tagAndMemo {
  color: #606266;
  font-size: 12px;
  font-weight: bold;
  line-height: 40px;
  height: 40px;
  border-bottom: 1px solid #e8eaec;
  box-sizing: border-box;
  margin-bottom: 20px;
  padding-left: 20px;
}

/deep/ .el-col-2 {
  width: 6.5%;
}

.gj-picker__editor {
  width: 450px;
  padding: 0;
}

.gj-picker__table {
  width: 600px;
  border-left: 0;
  padding: 12px 24px 0;
}

.el-tag /deep/ .el-tag__close {
  color: rgb(255, 153, 0);
}

.el-tag /deep/ .el-tag__close:hover {
  color: #fff;
  background-color: rgb(255, 153, 0);
}

/deep/ .gj-modal--table .el-dialog {
  height: 520px;
}

.setting-icon {
  font-size: 16px;
  margin-left: 4px;
  display: none;
  cursor: pointer;
}

.setting-wrapper{
  margin-bottom: 20px;
}
.setting-wrapper:hover .setting-icon {
  display: inline;
  line-height: 1;
}
</style>